import { MaxBrainWidget } from './widget.model';

export class WidgetCommand {
    name: string;

    constructor(tempWidget: MaxBrainWidget) {
        this.name = tempWidget.name;
    }
}
